import { AppModule } from 'app/module';
import './styles.scss';

export class JobsListHeader extends AppModule {
    domBindings() {
        return {
            container: '.m-jobsListHeader__container',
            title: '.m-jobsListHeader__title',
        };
    }

    hideHeadline() {
        this.dom.container.classList.add('m-jobsListHeader__container--hide');
        this.dom.title.classList.add('m-jobsListHeader__title--hide');
    }

    showHeadline() {
        this.dom.container.classList.remove('m-jobsListHeader__container--hide');
        this.dom.title.classList.remove('m-jobsListHeader__title--hide');
    }
}
